var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSignOut = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentColor",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 10C3 9.44772 3.44772 9 4 9H6V6C6 6 6 2 10 2C14 2 14 6 14 6V9H16C16.5523 9 17 9.44772 17 10V17C17 17.5523 16.5523 18 16 18H4C3.44772 18 3 17.5523 3 17V10ZM10 3.5C12.5 3.5 12.5 6 12.5 6V9H7.5L7.5 6C7.5 6 7.50003 3.5 10 3.5ZM11.25 12.25C11.25 12.7347 10.9741 13.155 10.5708 13.3624C10.5745 13.3753 10.5777 13.3885 10.5804 13.4019L10.8804 14.9019C10.9423 15.2113 10.7056 15.5 10.3901 15.5H9.6099C9.29438 15.5 9.05773 15.2113 9.11961 14.9019L9.41961 13.4019C9.42229 13.3885 9.4255 13.3753 9.4292 13.3624C9.02589 13.155 8.75 12.7347 8.75 12.25C8.75 11.5596 9.30964 11 10 11C10.6904 11 11.25 11.5596 11.25 12.25Z"
})));
export default SvgSignOut;